<template>
   <div>
              
            <h6 class="card-subtitle mb-2 text-muted float-left"> {{$t('timetable.import_from_time')}} {{ importLogDay }}</h6> 
            <br/>

            <TableActionHeader @filterChange="onFilterChange" :newButton="false"></TableActionHeader>
            <b-table id="logtable" 
                striped hover 
                :items="importLogsData" :fields="fields"
                :responsive="true"
                :small="true"
                :sort-by.sync="sortBy"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                @filtered="onFiltered">
                <template v-slot:cell(logTime)="data">
                    {{ data.value.substr(11,12) }}
                </template>
                <template v-slot:cell(logText)="data">
                    <div class="text-left">{{ data.value }}</div>
                </template>
            </b-table>

            <TablePagination 
                :total-rows="totalRows" 
                :per-page="perPage" 
                :currentPage="currentPage"
                @pageChange="onPageChange">
            </TablePagination>

    </div>
       
</template>

<script>
import moment from 'moment';
import importLog from '@/store/timetable/ImportLog'
import TablePagination from '@/components/Misc/TablePagination'
import TableActionHeader from '@/components/Misc/TableActionHeader'

export default {
    name: 'importLogsTable',
    components: { TablePagination, TableActionHeader },
    data: function() {
        return {
            fields: [ {key:"logTime",label:"Time"},
            { key:"logLevel",label:"Level"},
            { key:"logText" , label:"Text"} ],
            sortBy: "logTime",
            perPage: 5,
            currentPage: 1,
            totalRows: 1,
            filter:"",
            title:"Import lokit ajalta"
        }
    },
    computed: {
        importLogsData () {
            return this.$store.state.importLog.selectedDayLogs;
        },
        importLogDay() {
            var selDay = this.$store.state.importLog.selectedDay;
            if( selDay == null )
                return " - ";
            else
                return moment(selDay).format("YYYY-MM-DD");
        }
    },
    watch:{
        importLogsData: function(val) {
            if( val ) {
                this.totalRows = val.length;
                this.currentPage = 1
            } else {
                this.totalRows = 0
                this.currentPage = 1
            }
        }
    },
    created: function() {
        if (!this.$store.state.importLog) {
            this.$store.registerModule("importLog" , importLog);
        }
    },
    methods: {
        onPageChange(page){
            this.currentPage = page
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        onFilterChange(newfilter) {
            this.filter=newfilter
        }
    }
}
</script>